import { render } from "./ChooseSiteLang.vue?vue&type=template&id=6b70d4d1&ts=true"
import script from "./ChooseSiteLang.vue?vue&type=script&lang=ts"
export * from "./ChooseSiteLang.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__